<template>
    <block-section class="section">
        <div class="background-wrapper">
            <div
                class="background"
                :style="{ backgroundImage: `url(${imageUrl})` }"
            />
        </div>
        <div v-if="$slots.default" class="content">
            <slot />
        </div>
    </block-section>
</template>

<script>
const banners = [
    require("../../assets/images/banner_1_no_red.jpg"),
    require("../../assets/images/banner_2_no_red.jpg"),
    require("../../assets/images/banner_3_no_red.jpg"),
    require("../../assets/images/banner_4_no_red.jpg")
];

export default {
    props: {
        image: {
            type: [String, Number],
            required: false,
            default: 1,
            validator: function(val) {
                if (val instanceof Number && (val < 1 || val > 4)) return false;
                return true;
            }
        }
    },
    computed: {
        imageUrl() {
            if (this.image >= 1 && this.image <= 4)
                return banners[this.image - 1];
            return this.image;
        }
    }
};
</script>

<style scoped lang="scss">
.section {
    padding: 0;
    background-color: $color-primary;
    box-sizing: border-box;
    position: relative;
}

.background-wrapper {
    position: absolute;
    overflow: hidden;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}

.background {
    background-size: cover;
    background-position: top center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    min-height: 650px;
}

.content {
    max-width: 450px;
    margin: 0 auto;
    position: relative;
    background: rgba(0, 0, 0, 0.65);
    padding: 24px;
}

@media (min-width: 500px) {
    .section {
        padding: 2rem;
    }
}

@media (min-width: $breakpoint-tablet) {
    .section {
        padding-top: 4rem;
        padding-bottom: 4rem;
        min-height: 300px;
    }

    .content {
        max-width: 750px;
    }
}
</style>
